import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import { SesjaProvider } from "./sesja";
import { Aplikacja } from "./Aplikacja";
import { natywna } from "./uklad/instalacja"; // łapie beforeinstallprompt od startu - przycisk instalacji (PrzyciskInstalacji.tsx)
import { odswiezSlownik } from "./i18n/t";
import "./styles/wspolne.css";

// Ten sam adres i zakres SW co w starej APP (public/sw.js) - przełączenie bez reinstalacji. Aplikacja ze sklepu bez SW
// (paczka w telefonie; push i akcje powiadomień natywnie - docs/pwa/NATYWNA.md).
if ("serviceWorker" in navigator && import.meta.env.PROD && !natywna()) {
  navigator.serviceWorker.register("/sw.js", { scope: "/" }).catch(() => undefined);
}

// Po wdrożeniu nowej wersji otwarta APP nie znajdzie starych modułów ekranów (nowe nazwy plików) - zamiast białego
// ekranu przeładowanie na nową wersję. Najwyżej raz na minutę: przy trwałym błędzie (brak sieci) bez pętli.
window.addEventListener("vite:preloadError", (e) => {
  const KLUCZ = "iot-przeladowanie-wersji";
  let ostatnio = 0;
  try { ostatnio = Number(sessionStorage.getItem(KLUCZ)) || 0; } catch { /* bez pamięci sesji - przeładuj */ }
  if (Date.now() - ostatnio < 60_000) return;
  try { sessionStorage.setItem(KLUCZ, String(Date.now())); } catch { /* jw. */ }
  e.preventDefault();
  window.location.reload();
});

// Słownik języka: start z kopii w telefonie, świeży z serwera w tle (i18n/t.ts).
void odswiezSlownik();

const korzen = document.getElementById("app");
if (korzen) {
  createRoot(korzen).render(
    <StrictMode>
      <BrowserRouter>
        <SesjaProvider>
          <Aplikacja />
        </SesjaProvider>
      </BrowserRouter>
    </StrictMode>,
  );
}
